var _defs, _g, _polygon, _polygon2, _path, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 225.88 142.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#eaeaea;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:#59595b;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 190.33,
    y1: 10.69,
    x2: 225.88,
    y2: 10.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dbdbdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e9e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 11.01,
    y1: 65.28,
    x2: 216.07,
    y2: 65.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -5999.04,
    y1: -2657.91,
    x2: -5963.5,
    y2: -2657.91,
    gradientTransform: "translate(-5963.34 -2538.62) rotate(180)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "200.12 5.9 199.96 18.58 190.25 12.68 190.41 0 200.12 5.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "190.33 0 225.88 0.36 225.76 21.37 213.19 13.79 202.9 7.58 190.33 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "225.76 21.37 225.8 34.06 215.91 28.16 216.07 15.48 225.76 21.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "200.14 5.9 216.07 15.48 26.94 124.67 11.01 115.09 200.14 5.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "216.07 15.48 215.91 28.16 27.5 137.36 26.94 124.67 216.07 15.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "35.7 129.97 35.7 142.96 0 142.3 0.16 129.62 35.7 129.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "35.7 129.97 0.16 129.62 0.27 108.6 12.85 116.18 23.13 122.39 35.7 129.97"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "85.47 47.48 82.73 63.52 80.12 65.03 78.05 56.55 76.04 67.39 73.43 68.89 70.6 56.06 73.18 54.58 74.91 63.84 76.95 52.4 79.14 51.13 81.23 60.21 82.9 48.97 85.47 47.48"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "89.62 45.08 89.66 59.52 87.08 61.01 87.03 46.58 89.62 45.08"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100.9,41.88a6,6,0,0,1,.74,3.17v.66a11.64,11.64,0,0,1-.71,4,12.3,12.3,0,0,1-2,3.6,10.72,10.72,0,0,1-3,2.58l-3.89,2.25L92,43.7l3.86-2.23a5.32,5.32,0,0,1,3-.86A2.59,2.59,0,0,1,100.9,41.88ZM99,47.31v-.76c0-1.47-.28-2.42-.81-2.87s-1.3-.39-2.32.2l-1.28.74,0,9.63,1.25-.72a5.79,5.79,0,0,0,2.32-2.48A8.44,8.44,0,0,0,99,47.31"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "112.22 32.03 112.23 34.45 108.38 36.67 108.41 48.7 105.83 50.19 105.79 38.16 102 40.35 101.99 37.94 112.22 32.03"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "123.92 25.28 123.96 39.72 121.37 41.22 121.35 35.03 116.31 37.94 116.32 44.13 113.74 45.62 113.7 31.18 116.28 29.69 116.3 35.54 121.34 32.63 121.33 26.78 123.92 25.28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidth);
export default __webpack_public_path__ + "static/media/width.9c8281597d860f3e88d7e490813a12f5.svg";
export { ForwardRef as ReactComponent };